<template>
  <div>
    <v-card v-if="showGraph" elevation="0" class="rounded-lg">
      <circular-progress :graphData="graphData" :loading="loading" />

      <v-card-text>
        <div class="px-0 px-sm-10" v-for="(data, index) in datas" :key="index">
          <course-statistics-skeleton v-if="loading" />

          <div v-else class="d-flex align-center">
            <v-icon :color="data.iconColor" size="20">{{ data.icon }}</v-icon>

            <span
              class="
                text-start
                body-2
                textLight--text
                flex-grow-1 flex-shrink-0
                ps-5
              "
              style="opacity: 0.8"
            >
              {{ data.text }}
            </span>

            <span class="subtitle-1 textLight--text">{{ data.value }}</span>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-row v-else class="">
      <v-col
        v-for="(data, index) in datas"
        :key="index"
        cols="12"
        sm="6"
        class="text-start"
        :class="index > 1 ? 'pt-2' : ''"
      >
        <course-statistics-skeleton
          v-if="loading"
          class="pa-2 align-center px-lg-5"
        />

        <v-card
          v-else
          class="pa-2 d-flex align-center px-lg-5 mouse-cursor"
          flat
          :color="
            $vuetify.theme.dark ? data.darkModeColor : data.backgroundColor
          "
        >
          <v-icon :color="data.iconColor" size="20">{{ data.icon }}</v-icon>

          <span
            class="
              text-start
              body-2
              textLight--text
              flex-grow-1 flex-shrink-0
              ps-5
            "
            style="opacity: 0.8"
          >
            {{ data.text }}
          </span>

          <span class="subtitle-1 textLight--text">{{ data.value }}</span>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CircularProgress from "./ProfileCircularProgress.vue";
import { readFromLocalStorage } from "../../core-module/util/localStorageHandler";
import CourseStatisticsSkeleton from "./skeleton-loaders/CourseStatisticsLoader.vue";

export default {
  components: { CircularProgress, CourseStatisticsSkeleton },
  props: {
    showGraph: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: true,
      graphData: [
        {
          progress: 0,
          color: "#69F0AE",
          emptyColor: "#69f0ae38",
        },
        {
          progress: 0,
          color: "#5928E5",
          emptyColor: "#5928e538",
        },
        {
          progress: 0,
          color: "#FF5252",
          emptyColor: "#ff525238",
        },
      ],
      datas: [
        {
          icon: "mdi-sync",
          iconColor: "primary",
          text: this.$t("course.onGoingCourses.onGoingCourses"),
          key: "Ongoing",
          value: 0,
          backgroundColor: "#DED4FA",
          darkModeColor: "#3807c1",
        },
        {
          icon: "mdi-check-circle-outline",
          iconColor: "accent",
          text: this.$t("course.statistics.completedCourses"),
          key: "Completed",
          value: 0,
          backgroundColor: "#E1FCEF",
          darkModeColor: "#5dbb8e",
        },
        {
          icon: "mdi-alert-outline",
          iconColor: "error",
          text: this.$t("course.statistics.aboutToDue"),
          key: "Due",
          value: 0,
          backgroundColor: "#FFDCDC",
          darkModeColor: "#f39797",
        },
        {
          icon: "mdi-alert-octagon-outline",
          iconColor: "error",
          text: this.$t("course.assignedCourses.assignedCourses"),
          key: "Assigned",
          value: 0,
          backgroundColor: "#FFC5B3",
          darkModeColor: "#fb7c54",
        },
      ],
    };
  },
  apollo: {
    getTraineeStatistics() {
      return {
        query: require("@/app/user-module/api/query/getTraineeStatistics.gql"),
        variables: {
          id:
            this.$route.name === "PublicProfile"
              ? this.$route.params.id
              : this.$store.state.authenticatedUser?._id,
        },
        result({ data, loading }) {
          if (data && data.getTraineeStatistics) {
            this.datas.map(obj => {
              if (obj.key === "Completed") {
                obj.value = data.getTraineeStatistics.completedCourses
                  ? data.getTraineeStatistics.completedCourses
                  : 0;
                this.graphData[0].progress =
                  data.getTraineeStatistics.completedCourses;
              }
              if (obj.key === "Ongoing") {
                obj.value = data.getTraineeStatistics.ongoingCourses
                  ? data.getTraineeStatistics.ongoingCourses
                  : 0;
                this.graphData[1].progress =
                  data.getTraineeStatistics.ongoingCourses;
              }
              if (obj.key === "Due") {
                obj.value = data.getTraineeStatistics.aboutDueCourses
                  ? data.getTraineeStatistics.aboutDueCourses
                  : 0;
                this.graphData[2].progress =
                  data.getTraineeStatistics.aboutDueCourses +
                  data.getTraineeStatistics.assignedCourses;
              }
              if (obj.key === "Assigned") {
                obj.value = data.getTraineeStatistics.assignedCourses
                  ? data.getTraineeStatistics.assignedCourses
                  : 0;
                this.graphData[2].progress =
                  data.getTraineeStatistics.aboutDueCourses +
                  data.getTraineeStatistics.assignedCourses;
              }
            });
          } else {
            this.datas.map(obj => {
              obj.value = 0;
            });
            this.graphData.map(obj => {
              obj.progress = 0;
            });
          }

          this.loading = loading;
        },
      };
    },
  },
};
</script>
